import React, { useState } from "react";
import { Redirect } from 'react-router';
import { SingleService } from "../../dumb/services/SingleService";

export class SingleServiceContainer extends React.Component<any, any> {

    constructor(props: any) {

        super(props);

        this.state = { 
            // contents: Array<Object>()
            contents: Object(),
            refresh: props.refresh
        }
    }

    // getSnapshotBeforeUpdate = () => {

    //     // console.log("before update")
    //     // return null
    // }

    // shouldComponentUpdate = () => {

    //     // if (this.state.refresh) {
    //     //     return true;
    //     // }
    //     // return false;
    // }
    
    componentDidUpdate = () => {

        // console.log("did upadate")
        // if(this.state.contents)
        // fetch(`api/jsonFiles/contents/${this.props.language}/${this.props.filename}.json`)
        // .then(response => response.json())
        // .then(data => {
        //     // console.log("data " + data)
        //     //console.log(data, typeof data)
        //     // 
        //     this.setState({ refresh: false })
        //     this.setState({ contents: data })
        // })
        // return null;
    }
    
    componentDidMount = () => {

        let str = this.props.filename.replace(/\s/g, "");

        console.log("did mount ", str)
        //this.setState({ title: this.props.title })
        fetch(`api/jsonFiles/contents/${this.props.language}/${str}.json`)
            .then(response => response.json())
            .then(data => {
                // console.log("data " + data)
                //console.log(data, typeof data)
                this.setState({ contents: data })
            })
        return null;
    }

    componentWillUnmount = () => {
        console.log("will unmount")
        this.props.history.goForward();
        // console.log(this.state.refresh)
        // this.setState({ refresh: true })
    }
    
    
    
    render = () => {
        return (
            <div id="homeless-container">
                {this.props.redirect ? (
                    <Redirect push to="/home" />
                ) : (
                        
                        <SingleService contents={this.state.contents} filename={this.props.filename} clickhandler={this.props.clickhandler}/>
                    )}
            </div>
        );
    }
}